/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../api/common';
import '../common/common';
import '../../common/gateways';
import '../../payments/auth';
import '../../common/tender';
import '../../common/instrument';
import '../../common/emv';
import '../../bills/tender';
import '../../binfo/api';
import '../../payments/common';
import '../../common/network_token';
import '../../panhandler/service';
import '../../common/currency';
import '../../payments/push_money';
import '../common/endpoint_info';
import '../common/metadata';
import './gateway';
import '../common/scheme';
import './reverse';
import './capture';
import './refund';
import './purchase';
import './push_money';
import './request_metrics';
import '../api/itemization';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "AuthorizationOptions": {
                "fields": {
                  "tivoOnUs": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "tivoReplay": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "squareWallet": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "forUnlinkedRefund": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "isRecordFailedAuthorization": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "productSubcategory": {
                    "type": ".squareup.esperanto.api.ProductSubcategory",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": "NONE"
                    }
                  },
                  "isThirdPartyGiftCard": {
                    "type": "bool",
                    "id": 7,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "processingCode": {
                    "type": ".squareup.esperanto.api.ProcessingCode",
                    "id": 8,
                    "rule": "optional",
                    "options": {
                      "default": "USE_DEFAULT"
                    }
                  },
                  "addressSource": {
                    "type": ".squareup.esperanto.common.AddressSource",
                    "id": 9,
                    "rule": "optional"
                  },
                  "variableCapturePossible": {
                    "type": "bool",
                    "id": 10,
                    "rule": "optional"
                  },
                  "targetGateway": {
                    "type": ".squareup.common.gateways.GatewayName",
                    "id": 11,
                    "rule": "optional"
                  },
                  "posSpecialConditionIndicator": {
                    "type": ".squareup.esperanto.api.PosSpecialConditionIndicator",
                    "id": 12,
                    "rule": "optional"
                  },
                  "issuerInstallmentDetails": {
                    "type": ".squareup.esperanto.api.IssuerInstallmentDetails",
                    "id": 13,
                    "rule": "optional"
                  },
                  "usePreauthorization": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional"
                  },
                  "installmentDetails": {
                    "type": ".squareup.esperanto.api.InstallmentDetails",
                    "id": 15,
                    "rule": "optional"
                  },
                  "clientRequestedAuthType": {
                    "type": ".squareup.payments.auth.AuthorizationType",
                    "id": 16,
                    "rule": "optional"
                  },
                  "requestedAuthType": {
                    "type": ".squareup.payments.auth.AuthorizationType",
                    "id": 17,
                    "rule": "optional"
                  }
                }
              },
              "Tender": {
                "fields": {
                  "inputType": {
                    "type": ".squareup.common.tender.TenderInputType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "instrumentType": {
                    "type": ".squareup.common.instrument.InstrumentType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "expirationDateYymm": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "panMasked": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "panFideliusToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "balanceToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "cardPresent": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  },
                  "serviceCode": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "nameOnCard": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "keyedInZipcode": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "chipApplicationId": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "cvmResults": {
                    "type": ".squareup.common.CardholderVerificationMethodResults",
                    "id": 14,
                    "rule": "optional"
                  },
                  "applicationPreferredName": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "mobilePaymentSystem": {
                    "type": ".squareup.esperanto.model.MobilePaymentSystem",
                    "id": 16,
                    "rule": "optional"
                  },
                  "chipCardPreferredLanguageCode": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "cardFingerprint": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "tokenData": {
                    "type": ".squareup.common.tender.TokenData",
                    "id": 19,
                    "rule": "optional"
                  },
                  "terminalAccountType": {
                    "type": ".squareup.bills.CardTender.AccountType",
                    "id": 20,
                    "rule": "optional"
                  },
                  "iccApplicationIds": {
                    "type": "string",
                    "id": 21,
                    "rule": "repeated"
                  },
                  "felicaBrandId": {
                    "type": ".squareup.common.tender.FelicaCard.FelicaBrand",
                    "id": 22,
                    "rule": "optional"
                  },
                  "felicaTransactionId": {
                    "type": "string",
                    "id": 24,
                    "rule": "optional"
                  },
                  "binProperties": {
                    "type": ".squareup.binfo.api.BinProperties",
                    "id": 25,
                    "rule": "optional"
                  },
                  "originalTrack2Length": {
                    "type": "int32",
                    "id": 26,
                    "rule": "optional"
                  },
                  "originalPanFideliusToken": {
                    "type": "string",
                    "id": 27,
                    "rule": "optional"
                  },
                  "customerDescriptor": {
                    "type": "string",
                    "id": 28,
                    "rule": "optional"
                  },
                  "paymentAccountReference": {
                    "type": "string",
                    "id": 29,
                    "rule": "optional"
                  },
                  "serverCompletedBrand": {
                    "type": ".squareup.common.tender.ServerCompleted.ServerCompletedBrand",
                    "id": 30,
                    "rule": "optional"
                  },
                  "preAuthIdempotencyKey": {
                    "type": "string",
                    "id": 31,
                    "rule": "optional"
                  },
                  "cardOnFile": {
                    "type": ".squareup.common.tender.CardOnFile",
                    "id": 32,
                    "rule": "optional"
                  },
                  "luhnStatus": {
                    "type": ".squareup.payments.common.LuhnStatus",
                    "id": 33,
                    "rule": "optional"
                  },
                  "applicationTransactionCounter": {
                    "type": "string",
                    "id": 34,
                    "rule": "optional"
                  },
                  "applicationPrimaryAccountNumberSequenceNumber": {
                    "type": "string",
                    "id": 35,
                    "rule": "optional"
                  },
                  "digitalWalletType": {
                    "type": ".squareup.common.tender.DigitalWalletType",
                    "id": 36,
                    "rule": "optional"
                  },
                  "networkTokenData": {
                    "type": ".squareup.common.NetworkTokenData",
                    "id": 37,
                    "rule": "optional"
                  },
                  "usedNetworkTokenPan": {
                    "type": "bool",
                    "id": 38,
                    "rule": "optional"
                  },
                  "preferredBrandName": {
                    "type": ".squareup.esperanto.model.PreferredBrandName",
                    "id": 39,
                    "rule": "optional"
                  },
                  "serverCompletedTransactionId": {
                    "type": "string",
                    "id": 40,
                    "rule": "optional"
                  },
                  "serverCompletedVersion": {
                    "type": ".squareup.common.tender.ServerCompleted.ServerCompletedVersion",
                    "id": 41,
                    "rule": "optional"
                  },
                  "derivedBrandName": {
                    "type": ".squareup.esperanto.model.Tender.DerivedBrandName",
                    "id": 42,
                    "rule": "optional"
                  },
                  "tokenRequestorId": {
                    "type": "string",
                    "id": 43,
                    "rule": "optional"
                  },
                  "clickToPayCheckoutData": {
                    "type": ".squareup.panhandler.service.TenderMetadata.ClickToPayCheckoutData",
                    "id": 44,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DerivedBrandName": {
                    "values": {
                      "DEFAULT_DERIVED_BRAND_NAME": 0,
                      "AFTERPAY": 1
                    }
                  }
                }
              },
              "Payer": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "AuthorizationIntentIccData": {
                "fields": {
                  "issuerApplicationData": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unpredictableNumber": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "applicationTransactionCounter": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "terminalVerificationResults": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "applicationInterchangeProfile": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "applicationPanSequenceNumber": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "cryptogramInformationData": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "transactionDate": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "terminalSerialNumber": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "terminalType": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "terminalCapabilities": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "pointOfServiceEntryMode": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "formFactorIndicator": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "amountAuthorisedNumeric": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "finalAmountAuthorisedNumericQuickchip": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "readerErrorCode": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "outcomeStatusCode": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  }
                }
              },
              "AuthorizationResultIccData": {
                "fields": {
                  "issuerAuthenticationData": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "issuerScript": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "issuerScriptTemplate1": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "issuerScriptTemplate2": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "authorizationResponseCode": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "AuthorizationIntent": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "totalAmount": {
                    "type": ".squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "taxAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardSurchargeAmount": {
                    "type": ".squareup.common.Money",
                    "id": 17,
                    "rule": "optional"
                  },
                  "variableCaptureRequested": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "allowPartial": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional",
                    "options": {
                      "default": false
                    }
                  },
                  "iccData": {
                    "type": ".squareup.esperanto.model.AuthorizationIntentIccData",
                    "id": 7,
                    "rule": "optional"
                  },
                  "customerPresence": {
                    "type": ".squareup.esperanto.common.CustomerPresence",
                    "id": 8,
                    "rule": "optional"
                  },
                  "emvTags": {
                    "type": ".squareup.common.EmvTags",
                    "id": 10,
                    "rule": "optional"
                  },
                  "senderInfo": {
                    "type": ".squareup.payments.pushmoney.SenderInfo",
                    "id": 11,
                    "rule": "optional"
                  },
                  "internalRecurringPaymentToken": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "externalRecurringPaymentToken": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "isFirstRecurringPaymentInSeries": {
                    "type": "bool",
                    "id": 14,
                    "rule": "optional"
                  },
                  "requestedStatementInfo": {
                    "type": ".squareup.esperanto.common.RequestedStatementInfo",
                    "id": 15,
                    "rule": "optional"
                  },
                  "storedCardPaymentData": {
                    "type": ".squareup.esperanto.api.StoredCardPaymentData",
                    "id": 16,
                    "rule": "optional"
                  },
                  "recipientInfo": {
                    "type": ".squareup.payments.common.PaymentAccountInfo",
                    "id": 18,
                    "rule": "optional"
                  },
                  "productSubcategory": {
                    "type": ".squareup.esperanto.api.ProductSubcategory",
                    "id": 19,
                    "rule": "optional"
                  }
                }
              },
              "AuthorizationResult": {
                "fields": {
                  "status": {
                    "type": ".squareup.esperanto.common.OperationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "autoVoid": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "approvalCode": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cvvResponse": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "avsResponse": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "statementDescription": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "approvedAmount": {
                    "type": ".squareup.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "remainingBalanceAmount": {
                    "type": ".squareup.common.Money",
                    "id": 9,
                    "rule": "optional"
                  },
                  "declineReason": {
                    "type": ".squareup.payments.auth.AuthorizationError",
                    "id": 10,
                    "rule": "optional"
                  },
                  "iccData": {
                    "type": ".squareup.esperanto.model.AuthorizationResultIccData",
                    "id": 11,
                    "rule": "optional"
                  },
                  "cvvStatus": {
                    "type": ".squareup.payments.common.CvvStatus",
                    "id": 12,
                    "rule": "optional"
                  },
                  "avsStatus": {
                    "type": ".squareup.payments.common.AvsStatus",
                    "id": 13,
                    "rule": "optional"
                  },
                  "failureReasons": {
                    "type": ".squareup.payments.auth.AuthorizationError",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "gatewayTenderToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "emvTags": {
                    "type": ".squareup.common.EmvTags",
                    "id": 16,
                    "rule": "optional"
                  },
                  "settlementShard": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "fpanLast4": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "signatureBehavior": {
                    "type": ".squareup.bills.CardTender.Authorization.SignatureBehavior",
                    "id": 19,
                    "rule": "optional"
                  },
                  "recurringPaymentToken": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "felicaMaskedCardNumber": {
                    "type": "string",
                    "id": 21,
                    "rule": "optional"
                  },
                  "felicaSprwId": {
                    "type": "string",
                    "id": 22,
                    "rule": "optional"
                  },
                  "accountUpdaterResult": {
                    "type": ".squareup.esperanto.common.AccountUpdaterResult",
                    "id": 23,
                    "rule": "optional"
                  },
                  "computedAuthSloSuccessIndicator": {
                    "type": "bool",
                    "id": 24,
                    "rule": "optional"
                  },
                  "networkSequenceIdentifier": {
                    "type": "string",
                    "id": 25,
                    "rule": "optional"
                  },
                  "storedCardPaymentData": {
                    "type": ".squareup.esperanto.api.StoredCardPaymentData",
                    "id": 26,
                    "rule": "optional"
                  },
                  "gatewayCategorization": {
                    "type": ".squareup.esperanto.common.GatewayCategorization",
                    "id": 27,
                    "rule": "optional"
                  },
                  "declineRetryCategory": {
                    "type": ".squareup.esperanto.common.DeclineRetryCategory",
                    "id": 28,
                    "rule": "optional"
                  },
                  "gatewayAccountNumber": {
                    "type": "string",
                    "id": 29,
                    "rule": "optional"
                  },
                  "adviceCode": {
                    "type": ".squareup.esperanto.common.AdviceCode",
                    "id": 30,
                    "rule": "optional"
                  },
                  "cardNetwork": {
                    "type": ".squareup.payments.common.CardNetwork",
                    "id": 31,
                    "rule": "optional"
                  },
                  "selectedAcquirer": {
                    "type": ".squareup.payments.common.AcquiringEntity",
                    "id": 32,
                    "rule": "optional"
                  },
                  "authenticationResponseData": {
                    "type": ".squareup.esperanto.common.AuthenticationResponseData",
                    "id": 33,
                    "rule": "optional"
                  }
                }
              },
              "AdditionalAuthorization": {
                "fields": {
                  "idempotenceKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "authIntent": {
                    "type": ".squareup.esperanto.model.AuthorizationIntent",
                    "id": 2,
                    "rule": "optional"
                  },
                  "authResult": {
                    "type": ".squareup.esperanto.model.AuthorizationResult",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CardTransaction": {
                "fields": {
                  "clientEndpointInfo": {
                    "type": ".squareup.esperanto.common.EndpointInfo",
                    "id": 2,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": ".squareup.esperanto.common.Metadata",
                    "id": 3,
                    "rule": "optional"
                  },
                  "gatewayData": {
                    "type": ".squareup.esperanto.model.GatewayData",
                    "id": 4,
                    "rule": "optional"
                  },
                  "schemeData": {
                    "type": ".squareup.esperanto.common.SchemeData",
                    "id": 33,
                    "rule": "optional"
                  },
                  "tender": {
                    "type": ".squareup.esperanto.model.Tender",
                    "id": 5,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": ".squareup.esperanto.api.Merchant",
                    "id": 6,
                    "rule": "optional"
                  },
                  "creatorToken": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "payer": {
                    "type": ".squareup.esperanto.model.Payer",
                    "id": 7,
                    "rule": "optional"
                  },
                  "authIntent": {
                    "type": ".squareup.esperanto.model.AuthorizationIntent",
                    "id": 8,
                    "rule": "optional"
                  },
                  "authResult": {
                    "type": ".squareup.esperanto.model.AuthorizationResult",
                    "id": 9,
                    "rule": "optional"
                  },
                  "additionalAuthorization": {
                    "type": ".squareup.esperanto.model.AdditionalAuthorization",
                    "id": 36,
                    "rule": "repeated"
                  },
                  "void": {
                    "type": ".squareup.esperanto.model.Void",
                    "id": 19,
                    "rule": "repeated"
                  },
                  "capture": {
                    "type": ".squareup.esperanto.model.Capture",
                    "id": 18,
                    "rule": "repeated"
                  },
                  "refund": {
                    "type": ".squareup.esperanto.model.Refund",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "purchaseIntent": {
                    "type": ".squareup.esperanto.model.PurchaseIntent",
                    "id": 20,
                    "rule": "optional"
                  },
                  "purchaseResult": {
                    "type": ".squareup.esperanto.model.PurchaseResult",
                    "id": 21,
                    "rule": "optional"
                  },
                  "pushMoneyIntent": {
                    "type": ".squareup.esperanto.model.PushMoneyIntent",
                    "id": 23,
                    "rule": "optional"
                  },
                  "pushMoneyResult": {
                    "type": ".squareup.esperanto.model.PushMoneyResult",
                    "id": 24,
                    "rule": "optional"
                  },
                  "options": {
                    "type": ".squareup.esperanto.model.AuthorizationOptions",
                    "id": 15,
                    "rule": "optional"
                  },
                  "tivoRecord": {
                    "type": ".squareup.esperanto.common.TivoRecord",
                    "id": 16,
                    "rule": "optional"
                  },
                  "messageType": {
                    "type": ".squareup.payments.common.MessageType",
                    "id": 22,
                    "rule": "optional"
                  },
                  "refundCardPresenceRequirement": {
                    "type": ".squareup.bills.Tender.RefundCardPresenceRequirement",
                    "id": 25,
                    "rule": "optional",
                    "options": {
                      "default": "REFUND_CARD_PRESENCE_NOT_REQUIRED"
                    }
                  },
                  "linkedTenderServerToken": {
                    "type": "string",
                    "id": 26,
                    "rule": "optional"
                  },
                  "recurringPaymentToken": {
                    "type": "string",
                    "id": 27,
                    "rule": "optional"
                  },
                  "serverAttemptNumber": {
                    "type": "int32",
                    "id": 28,
                    "rule": "optional",
                    "options": {
                      "default": 1
                    }
                  },
                  "initialRequestTiming": {
                    "type": ".squareup.esperanto.model.RequestTiming",
                    "id": 29,
                    "rule": "optional"
                  },
                  "refundReservationType": {
                    "type": ".squareup.esperanto.model.RefundReservationType",
                    "id": 30,
                    "rule": "optional"
                  },
                  "failureProbability": {
                    "type": "float",
                    "id": 31,
                    "rule": "optional"
                  },
                  "itemizationData": {
                    "type": ".squareup.esperanto.api.ItemizationData",
                    "id": 32,
                    "rule": "repeated"
                  },
                  "networkSequenceIdentifier": {
                    "type": "string",
                    "id": 34,
                    "rule": "optional"
                  },
                  "storedCardPaymentData": {
                    "type": ".squareup.esperanto.api.StoredCardPaymentData",
                    "id": 35,
                    "rule": "optional"
                  }
                }
              },
              "MobilePaymentSystem": {
                "values": {
                  "DEFAULT_DO_NOT_USE": 0,
                  "APPLE_PAY": 1,
                  "ANDROID_PAY": 2
                }
              },
              "PreferredBrandName": {
                "values": {
                  "DEFAULT_PREFERRED_BRAND_NAME": 0,
                  "CLEARPAY": 1
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AuthorizationOptions && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.Tender && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.Tender?.nested?.DerivedBrandName && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.Payer && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AuthorizationIntentIccData && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AuthorizationResultIccData && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AuthorizationIntent && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AuthorizationResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AdditionalAuthorization && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CardTransaction && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.MobilePaymentSystem && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.PreferredBrandName) {
  $root.addJSON(jsonData);
}

/**
 * Set of authorization options.
 *
 * SOURCE AuthorizationOptions @ squareup/esperanto/model/auth.proto at 37:1
 */
export const AuthorizationOptions = $root.lookupType('squareup.esperanto.model.AuthorizationOptions');
fixType(AuthorizationOptions);
Builder.createAndAttachToType(AuthorizationOptions);
/**
 * Represents a tender.
 *
 * SOURCE Tender @ squareup/esperanto/model/auth.proto at 120:1
 */
export const Tender = $root.lookupType('squareup.esperanto.model.Tender');
fixType(Tender);
Builder.createAndAttachToType(Tender);
/**
 * SOURCE DerivedBrandName @ squareup/esperanto/model/auth.proto at 293:3
 */
Tender.DerivedBrandName = $root.lookupEnum('squareup.esperanto.model.Tender.DerivedBrandName').values;
/**
 * Payer information.
 *
 * SOURCE Payer @ squareup/esperanto/model/auth.proto at 325:1
 */
export const Payer = $root.lookupType('squareup.esperanto.model.Payer');
fixType(Payer);
Builder.createAndAttachToType(Payer);
/**
 * ICC-related data from the auth.
 *
 * All of these fields are hex-encoded.
 *
 * SOURCE AuthorizationIntentIccData @ squareup/esperanto/model/auth.proto at 334:1
 */
export const AuthorizationIntentIccData = $root.lookupType('squareup.esperanto.model.AuthorizationIntentIccData');
fixType(AuthorizationIntentIccData);
Builder.createAndAttachToType(AuthorizationIntentIccData);
/**
 * ICC-related data from the auth result.
 *
 * All of these fields are hex-encoded.
 *
 * SOURCE AuthorizationResultIccData @ squareup/esperanto/model/auth.proto at 359:1
 */
export const AuthorizationResultIccData = $root.lookupType('squareup.esperanto.model.AuthorizationResultIccData');
fixType(AuthorizationResultIccData);
Builder.createAndAttachToType(AuthorizationResultIccData);
/**
 * Authorization intent.
 *
 * SOURCE AuthorizationIntent @ squareup/esperanto/model/auth.proto at 384:1
 */
export const AuthorizationIntent = $root.lookupType('squareup.esperanto.model.AuthorizationIntent');
fixType(AuthorizationIntent);
Builder.createAndAttachToType(AuthorizationIntent);
/**
 * Authorization result.
 *
 * SOURCE AuthorizationResult @ squareup/esperanto/model/auth.proto at 476:1
 */
export const AuthorizationResult = $root.lookupType('squareup.esperanto.model.AuthorizationResult');
fixType(AuthorizationResult);
Builder.createAndAttachToType(AuthorizationResult);
/**
 * Information about an additional authorization after the initial authorization.  This is also
 * known as an "incremental auth".
 *
 * SOURCE AdditionalAuthorization @ squareup/esperanto/model/auth.proto at 616:1
 */
export const AdditionalAuthorization = $root.lookupType('squareup.esperanto.model.AdditionalAuthorization');
fixType(AdditionalAuthorization);
Builder.createAndAttachToType(AdditionalAuthorization);
/**
 * Credit (possibly debit) card authorization transaction.
 *
 * SOURCE CardTransaction @ squareup/esperanto/model/auth.proto at 630:1
 */
export const CardTransaction = $root.lookupType('squareup.esperanto.model.CardTransaction');
fixType(CardTransaction);
Builder.createAndAttachToType(CardTransaction);
/**
 * NFC mobile payment systems we care about, derived from various
 * EMV tags. See https://goo.gl/BZwxxu and https://goo.gl/i4TY0x for
 * original context.
 *
 * Note that each value indicates how accurate it is.
 * - A false positive means that the label is Apple/Android pay, but really it was a plastic card or something else.
 * - A false negative means that the label is missing, but really it was Apple/Android pay.
 *
 * SOURCE MobilePaymentSystem @ squareup/esperanto/model/auth.proto at 774:1
 */
export const MobilePaymentSystem = $root.lookupEnum('squareup.esperanto.model.MobilePaymentSystem').values;
/**
 * SOURCE PreferredBrandName @ squareup/esperanto/model/auth.proto at 787:1
 */
export const PreferredBrandName = $root.lookupEnum('squareup.esperanto.model.PreferredBrandName').values;